module.exports = __webpack_public_path__ + "img/broken-heart.88db5ff0.svg";